import i18n from 'i18next';

function phoneFormatter(phone: string) {
  // eslint-disable-next-line no-useless-escape
  return phone.replace(/\ |\(|\)|\-/gi, '');
}

function compactPriceFormatter(price) {
  if (price >= 10000) {
    const thousandShorthand = i18n.t('thousandShorthand');
    return `${Math.floor(price / 1000)}${thousandShorthand}`;
  }

  return price;
}

function priceFormatter(price: string | number | undefined = 0): string {
  if (!price && price !== 0) return '';

  const priceString = String(price);

  const parts = priceString.split('-');

  const formattedParts = parts.map((part) => {
    const partNumber = +part;
    if (isNaN(partNumber)) return '';

    return partNumber.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
  });

  return formattedParts.join(' - ').trim();
}

export { phoneFormatter, compactPriceFormatter, priceFormatter };
